import _get from 'lodash/get';
import Store from 'lightningjs-redux';
import { VIDEO_EVENTS } from '@bedrock/media-engine';
import { withPlayerPrefix } from '../../logic/player/player.constants';
import { playbackError } from '../../logic/player/player.actions';

export const playerDispatcher = (event, payload) => {
  if (event === VIDEO_EVENTS.ERROR) {
    const error = _get(payload, 'error.error', payload.error);
    Store.dispatch(playbackError(error));

    return;
  }

  if (event) {
    Store.dispatch({
      type: withPlayerPrefix(event.toUpperCase()),
      payload,
    });
  }
};
